module.exports = __webpack_public_path__ + "static/media/tablets.43f554ec.svg";